/* EBS Drawer Promo - gestione link pubblici, drawer nativo e copia codice */
(function () {
  'use strict';
  const ebs_hash = '#promo-vantaggi';
  if (window.Shopify?.designMode) document.documentElement.classList.add('ebs-promo-editor');


  const ebs_copy_timers = new WeakMap();

  function ebs_show_copy_tooltip(ebs_status, ebs_message, ebs_success = false) {
    if (!ebs_status) return;

    const ebs_previous_timer = ebs_copy_timers.get(ebs_status);

    if (ebs_previous_timer) {
      clearTimeout(ebs_previous_timer);
    }

    ebs_status.textContent = ebs_message;
    ebs_status.classList.add('is-visible');
    const ebs_button = ebs_status.closest('.ebs-drawer-promo-card-action-wrap')?.querySelector('.ebs-drawer-promo-copy');
    if (ebs_button) ebs_button.classList.toggle('is-copied', ebs_success);

    const ebs_timer = setTimeout(() => {
      ebs_status.classList.remove('is-visible');
      if (ebs_button) ebs_button.classList.remove('is-copied');
      ebs_copy_timers.delete(ebs_status);
    }, 3000);

    ebs_copy_timers.set(ebs_status, ebs_timer);
  }


  async function ebs_copy_text(ebs_text) {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(ebs_text);
      return;
    }
  
    // Fallback per contesti in cui Clipboard API non è disponibile
    const ebs_input = document.createElement('textarea');
  
    ebs_input.value = ebs_text;
    ebs_input.setAttribute('readonly', '');
    ebs_input.style.position = 'fixed';
    ebs_input.style.left = '-9999px';
  
    document.body.appendChild(ebs_input);
    ebs_input.select();
  
    try {
      if (!document.execCommand('copy')) {
        throw new Error('Clipboard copy failed');
      }
    } finally {
      ebs_input.remove();
    }
  }

  function ebs_drawer() { return document.querySelector('drawer-element'); }
  function ebs_ready() { return !!document.querySelector('#ebs-drawer-promo-content'); }
  function ebs_open(ebs_source) {
    const ebs_element = ebs_drawer();
    if (!ebs_element || !ebs_ready() || typeof ebs_element.open !== 'function') return false;
    const ebs_viewport = document.querySelector('.layout--viewport');
    if (ebs_viewport && ebs_viewport.getAttribute('data-drawer-view') === 'ebs-promo' &&
        ['opening', 'opened'].includes(ebs_viewport.getAttribute('data-drawer-status'))) return true;
    // Il drawer nativo cambia vista immediatamente sullo stesso lato,
    // mentre chiude prima un drawer attivo su un altro lato.
    ebs_element.open('left', 'ebs-promo', ebs_source || document.activeElement);
    return true;
  }


  // Chiude gli eventuali menu Bootstrap prima di aprire il drawer promo.
  function ebs_open_after_menus(ebs_source) {
    const ebs_modals = [...document.querySelectorAll('.ebs-mm.modal.show')];

    if (!ebs_modals.length || !window.bootstrap?.Modal) {
      return ebs_open(ebs_source);
    }

    let ebs_pending = ebs_modals.length;

    const ebs_finish = () => {
      ebs_pending -= 1;

      if (ebs_pending === 0) {
        const ebs_safe_trigger = document.querySelector(
          '.announcement--root .ebs-drawer-promo-trigger'
        );

        ebs_open(ebs_safe_trigger || document.body);
      }
    };

    ebs_modals.forEach((ebs_modal) => {
      ebs_modal.addEventListener('hidden.bs.modal', ebs_finish, { once: true });
      window.bootstrap.Modal.getOrCreateInstance(ebs_modal).hide();
    });

    return true;
  }


  function ebs_clear_hash() {
    if (location.hash === ebs_hash) {
      history.replaceState(history.state, '', location.pathname + location.search);
    }
  }
  document.addEventListener('click', function (ebs_event) {
    // Nel Theme Editor i clic sulla card devono selezionare il blocco, non navigare.
    if (window.Shopify && window.Shopify.designMode && ebs_event.target.closest('.ebs-drawer-promo-card')) {
      const ebs_link = ebs_event.target.closest('a');
      if (ebs_link) ebs_event.preventDefault();
      return;
    }
    const ebs_anchor = ebs_event.target.closest('a[href]');
    if (ebs_anchor) {
      const ebs_url = new URL(ebs_anchor.href, location.href);
      if (ebs_url.hash === ebs_hash && (ebs_url.pathname === location.pathname || ebs_url.pathname === "/") && ebs_url.origin === location.origin && (ebs_url.search === location.search || !ebs_url.search)) {
        if (ebs_ready()) {
          ebs_event.preventDefault();
          // Nei menu, blocca l'eventuale navigazione o apertura di altri sottomenu.
          ebs_event.stopPropagation();
          ebs_open_after_menus(ebs_anchor);
          ebs_clear_hash();
        }
        return;
      }
    }



    const ebs_copy = ebs_event.target.closest('.ebs-drawer-promo-copy');

    if (!ebs_copy || ebs_copy.disabled) return;

    ebs_event.preventDefault();
    ebs_event.stopPropagation();

    const ebs_code = ebs_copy.dataset.ebsCode;
    const ebs_status = ebs_copy.parentElement.querySelector(
      '.ebs-drawer-promo-card-copy-status'
    );

    if (!ebs_code) return;

    (async () => {
      try {
        await ebs_copy_text(ebs_code);
    
        ebs_show_copy_tooltip(
          ebs_status,
          'Codice copiato!',
          true
        );
    
      } catch (ebs_error) {
        console.error('EBS Drawer Promo: errore copia codice', ebs_error);
    
        ebs_show_copy_tooltip(
          ebs_status,
          'Impossibile copiare il codice',
          false
        );
      }
    })();



  }, true);

  function ebs_initial_hash() {
    if (location.hash === ebs_hash && ebs_open(document.querySelector('.ebs-drawer-promo-trigger'))) ebs_clear_hash();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ebs_initial_hash);
  else ebs_initial_hash();
  window.addEventListener('hashchange', ebs_initial_hash);
  // Ricollega i trigger nativi quando l'editor sostituisce le section.
  document.addEventListener('shopify:section:load', function () {
    const ebs_element = ebs_drawer();
    if (ebs_element && typeof ebs_element.loadTriggers === 'function') ebs_element.loadTriggers();
  });
  document.addEventListener('shopify:section:select', function (ebs_event) {
    if (ebs_event.target.classList.contains('ebs-drawer-promo-config-section')) ebs_open(ebs_event.target);
  });
  document.addEventListener('shopify:block:select', function (ebs_event) {
    if (ebs_event.target.closest('.ebs-drawer-promo-card')) ebs_open(ebs_event.target);
  });
})();
